import {Order, OrderEntry} from '../../interfaces/order';
import {calculateOrderMaterialItemValue} from './OrderAddUtils';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';



const getDateString = (date: Date | string | firebase.firestore.Timestamp): string => {
    if (date instanceof Date) {
        return date.toLocaleDateString();
    } else if (date instanceof firebase.firestore.Timestamp) {
        return new Date(date.toDate()).toLocaleDateString();
    } else if (typeof date === 'string') {
        return new Date(date).toLocaleDateString();
    }
    return 'empty date';
};

export const calculateDifferences = (appUrl: string, oldOrder: Order, newOrder: Order): string[] => {
    const oldAndNewDiffs = oldOrder.differences ? oldOrder.differences : [];
    const oldItems = oldOrder.items;
    const newItems = newOrder.items;
    oldAndNewDiffs.push(...handleBodyDiffs(oldOrder, newOrder));
    oldAndNewDiffs.push(...handleItemsDiffs(oldItems, newItems, appUrl));
    return oldAndNewDiffs;
};

const handleBodyDiffs = (oldOrder: Order, newOrder: Order) => {
    const diffs = [];
    if (oldOrder.vendor?.name !== newOrder.vendor?.name) {
        diffs.push(`<span style="color: rgb(37 108 200);">Changed vendor --></span> from "${oldOrder.vendor?.name}" to "${newOrder.vendor?.name}"`);
    }
    if (oldOrder.deliveryDate !== newOrder.deliveryDate) {
        const oldDate = getDateString(<string | Date>oldOrder.deliveryDate);
        const newDate = getDateString(<string | Date>newOrder.deliveryDate);
        if (oldDate !== newDate) {
            diffs.push(`<span style="color: rgb(37 108 200);">Changed delivery date --></span> from "${oldDate}" to "${newDate}"`);
        }
    }
    return diffs;
};

const handleItemsDiffs = (oldItems: OrderEntry[], newItems: OrderEntry[], appUrl: string): string[] => {
    const diffs = [];

    // removed
    for (const item of oldItems) {
        const found = newItems.find(newItem => compareItems(item, newItem));
        const total = calculateOrderMaterialItemValue(item.costEach, item.quantity, item.discount);
        if (!found) {
            const budgetLink = extractBudgetLink(appUrl, item);
            diffs.push(`<span style="color: red;">Removed item --></span> ${item.description} -- Total: ${total} -- Budget: ${budgetLink}`);
        }
    }

    // added
    for (const item of newItems) {
        const found = oldItems.find(oldItem => compareItems(item, oldItem));
        const total = calculateOrderMaterialItemValue(item.costEach, item.quantity, item.discount);
        if (!found) {
            const budgetLink = extractBudgetLink(appUrl, item);
            diffs.push(`<span style="color: green;">New item --></span> ${item.description} -- Total: ${total} -- Budget: ${budgetLink}`);
        }
    }
    return diffs;
};

const extractBudgetLink = (appUrl: string, item: OrderEntry) => {
    const projectNr = item.budget.project ? item.budget.project.projectNr : item.budget.budgetNr;
    return `<a href="${appUrl}#/budget/${item.budget.id}">${projectNr}</a>`;
};

const compareItems = (item1: OrderEntry, item2: OrderEntry) => {
    return item1.costEach === item2.costEach &&
        item1.description === item2.description &&
        item1.material?.description === item2.material?.description &&
        item1.material?.costEach === item2.material?.costEach;
};

export const compareMaterial = (mat1: any, mat2: any) => {
    if (!mat1 || !mat2) {
        return false;
    }
    const sameId = mat1.id && mat2.id && mat1.id === mat2.id;

    const sameDescr = mat1.description ? mat2.description.trim().toLowerCase() === mat1.description.trim().toLowerCase() : true;
    const sameUnit = mat1.unit ? mat2.unit.trim().toLowerCase() === mat1.unit.trim().toLowerCase() : true;
    return sameId || (sameDescr && sameUnit);
}
